<template>
  <div class="order-info">
    <div class="info-title">【{{ order.orderCode }}】{{ order.orderName }}</div>
    <jczh-descriptions
      :info="order"
      :option="orderInfoOption"
      :el-attrs="{ column: 4 }"
    />
  </div>
</template>

<script>
import { openDialog } from '@/utils/open-dialog'

export default {
  name: 'InquiryReviewHallOrder',

  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      orderInfoOption: [
        { label: '负责人', prop: 'releaserName' },
        { label: '联系方式', prop: 'releaserMobile' }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.order-info {
  background: $white-color;
  border-radius: 4px;
  padding: 24px 14px;

  .info-title {
    font-size: 16px;
    color: $text-color;
    margin-bottom: 24px;
  }

  ::v-deep .el-descriptions {
    width: 70%;
  }
}
</style>
